import React, { useState } from "react";
import { Modal, Input, message, Spin, Image } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import api from "../../context/api";
import ServiceImageUploader from "../imageUploader/ServiceImageUploader";
import "./main.scss";

const { TextArea } = Input;

const ServiceCard = ({ service, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title_uz: service.title_uz,
    title_ru: service.title_ru,
    title_en: service.title_en || '',
    text_uz: service.text_uz || '',
    text_ru: service.text_ru || '',
    text_en: service.text_en || '',
    imageFile: service.image_url
  });

  const deleteService = async () => {
    setLoading(true);
    try {
      await api.delete(`/service/${service.id}`);
      message.success("Xizmat muvaffaqiyatli o'chirildi");
      onUpdate();
    } catch (error) {
      console.error("Delete error:", error);
      message.error(error.response?.data?.message || "Xizmatni o‘chirishda xatolik yuz berdi");
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const updateService = async () => {
    setLoading(true);
    const formDataToSend = new FormData();
  
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (key === "imageFile") {
          // Only append if it's a new file
          if (value instanceof File) {
            formDataToSend.append("image_url", value);
          }
          // If it's a string (URL), don't send it again
        } else {
          formDataToSend.append(key, value);
        }
      }
    });
  
    try {
      await api.patch(`/service/${service.id}`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      message.success("Xizmat muvaffaqiyatli yangilandi");
      onUpdate();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Update error:", error);
      message.error(error.response?.data?.message || "Xizmatni yangilashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };
  

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      <div className="service-card">
        <div className="card-media">
          <Image
            src={service.image_url}
            alt={service.title_uz}
            preview={false}
            style={{
              width: '100%',
              height: '180px',
              objectFit: 'cover'
            }}
          />
          <div className="card-actions">
            <button 
              onClick={() => {
                setEditMode(true);
                setIsModalOpen(true);
              }}
            >
              <EditOutlined /> Tahrirlash
            </button>
            <button 
              onClick={() => {
                setEditMode(false);
                setIsModalOpen(true);
              }}
            >
              <DeleteOutlined /> O‘chirish
            </button>
          </div>
        </div>

        <div className="card-content">
          <h3>{service.title_uz}</h3>
          <p>{service.title_ru}</p>
        </div>
      </div>

      <Modal
        title={editMode ? "Xizmatni tahrirlash" : "Xizmatni o‘chirishni tasdiqlang"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={editMode ? 800 : 520}
      >
        <Spin spinning={loading}>
          {editMode ? (
            <div className="edit-form">
              <div className="current-image">
                <Image
                  src={typeof formData.imageFile === 'string' ? 
                    formData.imageFile : 
                    URL.createObjectURL(formData.imageFile)}
                  alt="Joriy rasm"
                  style={{ maxWidth: '100%', maxHeight: '200px' }}
                />
              </div>

              <ServiceImageUploader
                imageFile={formData.imageFile}
                setImageFile={(file) => handleFormChange('imageFile', file)}
              />

              <div className="form-group">
                <label>Sarlavha (O‘zbek)</label>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange('title_uz', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Sarlavha (Rus)</label>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange('title_ru', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Sarlavha (Ingliz)</label>
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange('title_en', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (O‘zbek)</label>
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange('text_uz', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (Rus)</label>
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange('text_ru', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Matn (Ingliz)</label>
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange('text_en', e.target.value)}
                />
              </div>

              <div className="form-actions">
                <button 
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button 
                  className="save-btn"
                  onClick={updateService}
                >
                  Saqlash
                </button>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <p>Ushbu xizmatni o‘chirmoqchimisiz?</p>
              <div className="confirmation-actions">
                <button 
                  className="cancel-btn"
                  onClick={() => setIsModalOpen(false)}
                >
                  Bekor qilish
                </button>
                <button 
                  className="confirm-delete-btn"
                  onClick={deleteService}
                >
                  Ha, o‘chirish
                </button>
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </>
  );
};

export default ServiceCard;
